import { connect } from "react-redux";
import HelfpfulLinksGrid from "./HelfpfulLinksGrid";
import { find, destroy, setSearch } from "../../../../../redux/modules/marketing/helpfulLink";

const mstp = (state) => ({
    ...state.tours,
    userInfo: state.login.userInfo,
});

const mdtp = { find, destroy, setSearch };

export default connect(mstp, mdtp)(HelfpfulLinksGrid);
